module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', [_c('div', {
    staticClass: "inbox"
  }, [_c('bsf-page-header', [_c('h3', {
    slot: "header"
  }, [_vm._v("swiper 组件")])]), _vm._v(" "), _c('breadcrumb', {
    attrs: {
      "data": _vm.$store.state.bcArray
    }
  })]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "6"
    }
  }, [_c('bsf-panel', {
    attrs: {
      "header": "swiper竖向"
    }
  }, [_c('swiper', {
    attrs: {
      "data": _vm.swiperData,
      "direction": "vertical",
      "height": "300"
    },
    slot: "body"
  })])]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "6"
    }
  }, [_c('bsf-panel', {
    attrs: {
      "header": "swiper横向"
    }
  }, [_c('swiper', {
    attrs: {
      "data": _vm.swiperData,
      "height": "300",
      "showArrow": ""
    },
    slot: "body"
  })])]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "6"
    }
  }, [_c('bsf-panel', {
    attrs: {
      "header": "swiper自动播放 3s"
    }
  }, [_c('swiper', {
    attrs: {
      "data": _vm.swiperData,
      "height": "300",
      "autoPlay": "3000"
    },
    slot: "body"
  })])]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "6"
    }
  }, [_c('bsf-panel', {
    attrs: {
      "header": "swiper自动播放 5s"
    }
  }, [_c('swiper', {
    attrs: {
      "data": _vm.swiperData,
      "height": "300",
      "autoPlay": "5000"
    },
    slot: "body"
  })])]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "4"
    }
  }, [_c('bsf-panel', {
    attrs: {
      "header": "fade效果"
    }
  }, [_c('swiper', {
    attrs: {
      "data": _vm.swiperData,
      "height": "200",
      "effect": "fade",
      "autoPlay": "5000"
    },
    slot: "body"
  })])]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "4"
    }
  }, [_c('bsf-panel', {
    attrs: {
      "header": "cube效果"
    }
  }, [_c('swiper', {
    attrs: {
      "data": _vm.swiperData,
      "height": "200",
      "effect": "cube",
      "autoPlay": "5000"
    },
    slot: "body"
  })])]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "4"
    }
  }, [_c('bsf-panel', {
    attrs: {
      "header": "flip效果"
    }
  }, [_c('swiper', {
    attrs: {
      "data": _vm.swiperData,
      "height": "200",
      "effect": "flip",
      "autoPlay": "5000"
    },
    slot: "body"
  })])]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "6"
    }
  }, [_c('bsf-panel', {
    attrs: {
      "header": "keyboardControl"
    }
  }, [_c('swiper', {
    attrs: {
      "data": _vm.swiperData,
      "height": "300",
      "keyboard": ""
    },
    slot: "body"
  })])]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "6"
    }
  }, [_c('bsf-panel', {
    attrs: {
      "header": "mousewheelControl"
    }
  }, [_c('swiper', {
    attrs: {
      "data": _vm.swiperData,
      "height": "300",
      "mouse": ""
    },
    slot: "body"
  })])]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "4"
    }
  }, [_c('bsf-panel', {
    attrs: {
      "header": "设置显示个数"
    }
  }, [_c('swiper', {
    attrs: {
      "data": _vm.swiperData,
      "height": "300",
      "mouse": "",
      "pv": 2
    },
    slot: "body"
  })])]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "4"
    }
  }, [_c('bsf-panel', {
    attrs: {
      "header": "设置显示个数 分组"
    }
  }, [_c('swiper', {
    attrs: {
      "data": _vm.swiperData,
      "height": "300",
      "mouse": "",
      "pv": 2,
      "pg": 2
    },
    slot: "body"
  })])]), _vm._v(" "), _c('bsf-col', {
    attrs: {
      "size": "xs",
      "col": "4"
    }
  }, [_c('bsf-panel', {
    attrs: {
      "header": "设置显示个数 间距"
    }
  }, [_c('swiper', {
    attrs: {
      "data": _vm.swiperData,
      "height": "300",
      "mouse": "",
      "pv": 3,
      "st": 30
    },
    slot: "body"
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.0.2@vue-loader/lib/template-compiler.js?id=data-v-968c0382!./~/.10.0.2@vue-loader/lib/selector.js?type=template&index=0!./src/views/swiper.vue
// module id = 330
// module chunks = 2